import { render, staticRenderFns } from "./CurveCategoryBasedMapping.vue?vue&type=template&id=5310a109&"
import script from "./CurveCategoryBasedMapping.vue?vue&type=script&lang=js&"
export * from "./CurveCategoryBasedMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports